import { normalizeAxiosResponse } from '../utils'
import { jobReq } from './models'

export const normalizeGetJobReq = (response) => {
  return normalizeAxiosResponse(response)(jobReq)
}
